import { useQuery } from '@tanstack/react-query';
import { dataService, Alert, AlertListResponse } from '../services/data';

interface UseAlertsParams {
  status?: 'active' | 'acknowledged' | 'resolved';
  severity?: 'warning' | 'critical';
  probe_id?: string;
  limit?: number;
  offset?: number;
}

export function useAlerts(params?: UseAlertsParams) {
  return useQuery<AlertListResponse, Error>({
    queryKey: ['alerts', params],
    queryFn: () => dataService.getAlerts(params),
  });
}

export function useAlert(id: string | undefined) {
  return useQuery<Alert, Error>({
    queryKey: ['alerts', id],
    queryFn: () => dataService.getAlert(id!),
    enabled: !!id,
  });
}
